import { writable } from 'svelte/store';
function createAppStore() {
    const { subscribe, set, update } = writable({
        token: '',
        client: null,
        profile: null,
        repositoryBranches: {}
    });
    return {
        subscribe,
        setToken: (token) => update(state => ({ ...state, token })),
        setClient: (client) => update(state => ({ ...state, client })),
        reset: () => update(state => ({ ...state, token: '', profile: null, repositoryBranches: {} })),
        setProfile: (profile) => update(state => ({ ...state, profile })),
        setBranches: (repoKey, branches, defaultBranch) => update(state => ({
            ...state,
            repositoryBranches: {
                ...state.repositoryBranches,
                [repoKey]: {
                    branches,
                    defaultBranch,
                    lastFetched: Date.now()
                }
            }
        })),
        getBranches: (repoKey, maxAge = 5 * 60 * 1000) => {
            let result = null;
            const unsubscribe = subscribe(state => {
                const cached = state.repositoryBranches[repoKey];
                if (cached && Date.now() - cached.lastFetched < maxAge) {
                    result = { branches: cached.branches, defaultBranch: cached.defaultBranch };
                }
            });
            unsubscribe();
            return result;
        }
    };
}
export const appStore = createAppStore();
